import { Form, Input, Button, Checkbox, Card, Image, notification } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { post } from "../../services/apiService";
import { companyState } from "../../lib/stores/companyId";
import { useRecoilState } from "recoil";
import "./forgot.css";
import { isLoadingState } from "../../store/loader";

const Forgot = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useRecoilState(isLoadingState);

  const onFinish = async (values: { userName: string }) => {
    try {
      setLoading(true);
      if (values?.userName !== "") {
        const response = await post("/api/auth/forgotPassword", values);
        if (response) {
          navigate("/login");
          setLoading(false);
          notification.success({
            message: response?.message,
          });
        } else {
          console.log("forgot Failed:", response);
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  return (
    <div
      style={{
        display: "grid",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        background: " #def5b8",
      }}
    >
      <Card
        className="card-styles"
        style={{
          background: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Image
          src={"/Juice_logo.png"}
          alt="logo"
          // width={200}
          // height={100}
          preview={false}
        />
        <Form
          name="normal_login"
          className="login-form"
          initialValues={{
            remember: false,
          }}
          onFinish={onFinish}
        >
          <Form.Item
            name="userName"
            rules={[
              {
                required: true,
                message: "This Field is required!",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Enter your Email"
            />
          </Form.Item>
          <Form.Item>
            <Button
              // loading={loading}
              type="primary"
              htmlType="submit"
              className="login-form-button"
              style={{ width: "100%" }}
            >
              Forgot Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Forgot;
